import { CL_DOUBLE_BAR_CHART_TITLE, EXPLORE_DOUBLE_BAR_CHART_TITLE } from '@pages/Utilities';
import { PageType } from '@utils/pageConfig/Types';

export const getDoubleBarChartComponentName = (pageType: PageType) => {
  switch (pageType) {
    case PageType.CATEGORY_LEADERBOARD:
      return CL_DOUBLE_BAR_CHART_TITLE;
    case PageType.EXPLORE:
      return EXPLORE_DOUBLE_BAR_CHART_TITLE;
    default:
      return '';
  }
};
